import './styles/quasar.scss';
import '@quasar/extras/roboto-font/roboto-font.css';
import '@quasar/extras/material-icons/material-icons.css';
import Dialog from 'quasar/src/plugins/Dialog.js';import LoadingBar from 'quasar/src/plugins/LoadingBar.js';import Notify from 'quasar/src/plugins/Notify.js';;

export default {
  config: {},
  plugins: {
    LoadingBar,
    Dialog,
    Notify,
  },
};
